import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import { Form as FinalForm } from 'react-final-form';
import css from './ChangeEmailModal.module.css';
// import { FormattedMessage } from 'react-intl';
import { FieldPassword, FieldTextInput, PrimaryButton, Form, Button } from '..';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as validators from '../../util/validators';
import { ensureCurrentUser } from '../../util/data';
import {
  isChangeEmailTakenError,
  isChangeEmailWrongPassword,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import { sendVerificationEmailError } from '../../ducks/user.duck';
import classNames from 'classnames';
import { isEqual } from 'lodash';

const textfield = 'textfield';
const errorTextField = 'errorTextField';

export default function ChangeEmailModal(props) {
  const [showVerificationEmailSentMessage, setShowVerificationEmailSentMessage] = useState(false);
  const [showResetPasswordMessage, setShowResetPasswordMessage] = useState(false);
  const [showEmailChangeModal, setShowEmailChangeModal] = useState(false);
  const [submittedValues, setSubmittedValues] = useState({});
  // console.log(props, 14);
  return (
    <Modal
      id="emailChangeModal"
      isOpen={props.showEmailChangeModal}
      onManageDisableScrolling={props.onManageDisableScrolling}
      onClose={() => props.setShowEmailChangeModal(false)}
      // className={css.emailChangeModalMain}
      // scrollLayerClassName={css.modalScrollLayer}
      // containerClassName={css.modalContainer}
      // contentClassName={css.modalContent}
      usePortal
      // onSubmit={e => {
      //  submitModalValue;
      // }}
    >
      <FinalForm
        intl={props.intl}
        currentUser={props.currentUser}
        initialValues={props.initialValues}
        onSubmit={props.onSubmitContactDetails}
        saveEmailError={props.saveEmailError}
        sendVerificationEmailInProgress={props.sendVerificationEmailInProgress}
        sendVerificationEmailError={props.sendVerificationEmailError}
        onResetPassword={props.onResetPassword}
        render={fieldProps => {
          const {
            intl,
            invalid,
            submitInProgress,
            handleSubmit,
            values,
            rootClassName,
            className,
            formId,
            resetPasswordInProgress,
            initialValues,
            currentUser,
            saveEmailError,
            sendVerificationEmailInProgress,
          } = fieldProps;

          const submitDisabled = invalid || submitInProgress;
          const { newEmail } = values;
          // console.log(989, values);
          const handleResendVerificationEmail = () => {
            setShowVerificationEmailSentMessage(true);

            props.onResendVerificationEmail().then(() => {
              const emailSentTimeoutId = window.setTimeout(() => {
                setShowVerificationEmailSentMessage(false);
              }, SHOW_EMAIL_SENT_TIMEOUT);
              return () => {
                window.clearTimeout(emailSentTimeoutId);
              };
            });
          };

          // email has changed

          const emailRequiredMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailRequired',
          });
          const emailExistMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailExist',
          });
          const emailRequired = validators.required(emailRequiredMessage);
          const emailInvalidMessage = intl.formatMessage({
            id: 'ContactInformationForm.emailInvalid',
          });
          const emailValid = validators.emailFormatValid(emailInvalidMessage);
          const modalEmailLabel = intl.formatMessage({
            id: 'ContactInformationForm.modalEmailLabel',
          });

          const emailExist = validators.isEmailExist(emailExistMessage);
          const emailValidator = validators.composeValidators(
            emailRequired,
            emailValid,
            emailExist
          );

          const user = ensureCurrentUser(currentUser);

          const { email: currentEmail, emailVerified, pendingEmail, profile } = user.attributes;
          const emailChanged = currentEmail !== newEmail;
 
          const tooManyVerificationRequests = isTooManyEmailVerificationRequestsError(
            sendVerificationEmailError
          );
          const emailTouched = submittedValues.email !== values.email;
          const emailTakenErrorText = isChangeEmailTakenError(saveEmailError)
            ? intl.formatMessage({
                id: 'ContactDetailsForm.emailTakenError',
              })
            : null;

          let resendEmailMessage = null;
          if (tooManyVerificationRequests) {
            resendEmailMessage = (
              <span className={css.tooMany}>
                <FormattedMessage id="ContactDetailsForm.tooManyVerificationRequests" />
              </span>
            );
          } else if (sendVerificationEmailInProgress || showVerificationEmailSentMessage) {
            resendEmailMessage = (
              <span className={css.emailSent}>
                <FormattedMessage id="ContactDetailsForm.emailSent" />
              </span>
            );
          } else {
            resendEmailMessage = (
              <span
                className={css.helperLink}
                onClick={handleResendVerificationEmail}
                role="button"
              >
                <FormattedMessage id="ContactDetailsForm.resendEmailVerificationText" />
              </span>
            );
          }

          // Email status info: unverified, verified and pending email (aka changed unverified email)
          let emailVerifiedInfo = null;

          if (emailVerified && !pendingEmail && !emailChanged) {
            // Current email is verified and there's no pending unverified email
            emailVerifiedInfo = (
              <span className={css.emailVerified}>
                <FormattedMessage id="ContactDetailsForm.emailVerified" />
              </span>
            );
          } else if (!emailVerified && !pendingEmail) {
            // Current email is unverified. This is the email given in sign up form

            emailVerifiedInfo = (
              <span className={css.emailUnverified}>
                <FormattedMessage
                  id="ContactDetailsForm.emailUnverified"
                  values={{ resendEmailMessage }}
                />
              </span>
            );
          } else if (pendingEmail) {
            // Current email has been tried to change, but the new address is not yet verified

            const pendingEmailStyled = <span className={css.emailStyle}>{pendingEmail}</span>;
            const pendingEmailCheckInbox = (
              <span className={css.checkInbox}>
                <FormattedMessage
                  id="ContactDetailsForm.pendingEmailCheckInbox"
                  values={{ pendingEmail: pendingEmailStyled }}
                />
              </span>
            );

            emailVerifiedInfo = (
              <span className={css.pendingEmailUnverified}>
                <FormattedMessage
                  id="ContactDetailsForm.pendingEmailUnverified"
                  values={{
                    pendingEmailCheckInbox,
                    resendEmailMessage,
                  }}
                />
              </span>
            );
          }

          const modalEmailPlaceholder = intl.formatMessage({
            id: 'ContactInformationForm.modalemailPlaceholder',
          });
          const modalPasswordLabel = intl.formatMessage({
            id: 'ContactInformationForm.modalPasswordLabel',
          });
          const modalpasswordPlaceholder = intl.formatMessage({
            id: 'ContactInformationForm.modalpasswordPlaceholder',
          });

          const passwordRequiredMessage = intl.formatMessage({
            id: 'ContactDetailsForm.passwordRequired',
          });
          const passwordRequired = validators.requiredStringNoTrim(passwordRequiredMessage);

          const passwordMinLengthMessage = intl.formatMessage(
            {
              id: 'ContactDetailsForm.passwordTooShort',
            },
            {
              minLength: validators.PASSWORD_MIN_LENGTH,
            }
          );

          const passwordMinLength = validators.minLength(
            passwordMinLengthMessage,
            validators.PASSWORD_MIN_LENGTH
          );

          const passwordValidators = emailChanged
            ? validators.composeValidators(passwordRequired, passwordMinLength)
            : null;

          const passwordFailedMessage = intl.formatMessage({
            id: 'ContactDetailsForm.passwordFailed',
          });
          // const passwordTouched = submittedValues.currentPassword !== values.currentPassword;
          const passwordTouched = submittedValues.password !== values.password;

          const passwordErrorText = isChangeEmailWrongPassword(saveEmailError)
            ? passwordFailedMessage
            : null;

          const classes = classNames(css.emailChangeRoot || rootClassName, className);
          const submittedOnce = Object.keys(submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, submittedValues);
          const emailId = formId ? `${formId}.email` : 'email';
          const passwordId = formId ? `${formId}.password` : 'password';

          function handleResetPassword() {
            setShowResetPasswordMessage(true);
            const email = props.currentUser.attributes.email;

            props.onResetPassword(email);
          }

          const sendPasswordLink = (
            <span
              className={css.helperLinkChangeEmailModal}
              onClick={handleResetPassword}
              role="button"
            >
              <FormattedMessage id="ContactDetailsForm.resetPasswordLinkText" />
            </span>
          );
          const resendPasswordLink = (
            <span
              className={css.helperLinkChangeEmailModal}
              onClick={handleResetPassword}
              role="button"
            >
              <FormattedMessage id="ContactDetailsForm.resendPasswordLinkText" />
            </span>
          );

          const resetPasswordLink =
            showResetPasswordMessage || resetPasswordInProgress ? (
              <>
                <FormattedMessage
                  id="ContactDetailsForm.resetPasswordLinkSent"
                  values={{
                    email: (
                      <span className={css.emailStyle}>{props.currentUser.attributes.email}</span>
                    ),
                  }}
                />{' '}
                {resendPasswordLink}
              </>
            ) : (
              sendPasswordLink
            );

          return (
            <Form
              className={classes}
              onSubmit={e => {
                setSubmittedValues(values);
                handleSubmit(e);
              }}
            >
              <h3 className={css.heading}>
                <FormattedMessage id="ContactInformationForm.ModalHeading" />
              </h3>
              <FieldTextInput
                className={textfield}
                errorClassName={errorTextField}
                type="email"
                id={'newEmail'}
                name="newEmail"
                // autoComplete="email"
                label={<span>{modalEmailLabel}</span>}
                placeholder={modalEmailPlaceholder}
                validate={emailValidator}
                // validate={validators.composeValidators(emailRequired, emailValid)}
                customErrorText={emailTouched ? null : emailTakenErrorText}
              />

              <FieldPassword
                className={classNames(css.password, textfield)}
                errorClassName={errorTextField}
                id={passwordId}
                type="password"
                name="password"
                label={
                  <span>
                    {modalPasswordLabel}
                    <p>
                      <FormattedMessage id="ContactInformationForm.modalPasswordlabelSecondLine" />
                    </p>
                  </span>
                }
                placeholder={modalpasswordPlaceholder}
                validate={passwordValidators}
                customErrorText={passwordTouched ? null : passwordErrorText}
                // validate={passwordValidators}
                // passwordCheckRefValues={[fname, lname, email]}
              />
              <p className={css.confirmChangesInfo}>
                <FormattedMessage
                  id="ContactDetailsForm.resetPasswordInfo"
                  values={{
                    resetPasswordLink,
                  }}
                />
              </p>
              {/* <PrimaryButton
                className={css.submitBtn1}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={pristineSinceLastSubmit}
              >
                <FormattedMessage id="ContactInformationForm.save" />
              </PrimaryButton> */}
              <Button
                className={css.submitBtn1}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                onClick={() => props.setShowEmailChangeModal(false)}
              >
                <FormattedMessage id="ProfileSettingsForm.saveChanges" />
              </Button>
            </Form>
          );
        }}
      />
    </Modal>
  );
}
